import React, { useState, useEffect } from 'react';
import { Modal, Table } from 'react-bootstrap';
// import { Modal, Button, Form, Spinner, Card, Table } from 'react-bootstrap';
// import { dedupedRequest, invalidateCacheByUrl } from '../utils/axios';
// import EditIcon from './icons/EditIcon';
// import PdfFile from './icons/PdfFile';

// type Topic = {
//   id: number;
//   name: string;
//   selected: boolean;
// };

// type ClientPayload = {
//   name?: string;
//   activity_trade?: string | null;
//   activity_description?: string | null;
//   employees?: number | null;
//   annual_turnover?: string | null;
//   standards?: string | null;
//   country_province?: string | null;
//   comments?: string | null;
//   topics?: number[];
// };

// Internal form state used by the UI:
// type FormState = Omit<ClientPayload, 'topics'> & {
//   topics?: Topic[];                 // <-- UI uses full objects with `selected`
// };

interface StandardModalProps {
  show: boolean;
  // ClientId: number;
  std: any;
  onClose: () => void;
}

const StandardModal: React.FC<StandardModalProps> = ({ show, std, onClose }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!std) return;
    setShowModal(show);
    // console.log(showModal, ClientId);
  }, [std]);

  // const logoUrl = std && std.logo_filename ? `/api/clients/${c.id}/logo` : null;

  // console.log(std);

  return (
    <Modal show={showModal} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Standard</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          <Table className='std-table'>
            <tbody>
              <tr className='std_head'>
                <td>Nr.:</td><td>{std.nr}</td>
              </tr>
              <tr className='std_row'>
                <td>Bezeichnung:</td><td>{std.name}</td>
              </tr>
              <tr className='std_row'>
                <td>Anstalt:</td><td>{std.institution}</td>
              </tr>
              <tr className='std_row'>
                <td>Berufsgruppe</td><td>{std.profession}</td>
              </tr>
              <tr className='std_row'>
                <td>Abkürzung</td><td>{std.abbr}</td>
              </tr>
              <tr className='std_row'>
                <td>Kategorie</td><td>{std.category}</td>
              </tr>
              <tr className='std_row'>
                <td>Dateiname</td><td>{std.filename}</td>
              </tr>
              <tr className='std_row'>
                <td>Kurzname</td><td>{std.short_name}</td>
              </tr>
              <tr className='std_row'>
                <td>Version:</td><td>{std.version}</td>
              </tr>
              <tr className='std_row'>
                <td>Revision:</td><td>{std.revision}</td>
              </tr>
              <tr className='std_row'>
                <td>Erstellt am:</td><td>{std.cre_date}</td>
              </tr>
              <tr className='std_row'>
                <td>Erstellt von:</td><td>{std.created_by}</td>
              </tr>
              <tr className='std_row'>
                <td>Geprüft von:</td><td>{std.examined_by}</td>
              </tr>
              <tr className='std_row'>
                <td>Freigabe:</td><td>{std.release}</td>
              </tr>
              <tr className='std_row'>
                <td>Klassifizierung:</td><td>{std.status}</td>
              </tr>
            </tbody>
          </Table>
        </>
      </Modal.Body>
    </Modal>
  );
};

export default StandardModal;
